/* ==========================================================================
   RYSE . HEADER - carregador                                   (rev. 5)
   --------------------------------------------------------------------------
   Este arquivo existe por causa de uma DEPENDENCIA, e nao por organizacao:
   o nucleo do header precisa de window.ryseRolagem ANTES de rodar, porque em
   algumas paginas deste tema quem rola nao e a janela. Carregar os dois na
   ordem aqui deixa a dependencia explicita.

   ==========================================================================
   O BUG QUE ESTE ARQUIVO CAUSAVA - e que so apareceu meses depois
   --------------------------------------------------------------------------
   A versao anterior montava a URL dos filhos assim:

       src.replace(/ryse-header\.js.*$/, '')  +  'ryse-rolagem.js'

   O `.*$` engolia tambem a QUERY STRING. E a query do Shopify (?v=<hash>) e
   justamente o que diz ao CDN e ao navegador que o arquivo mudou. Sem ela, o
   pedido vai pra uma URL estavel - e volta a revisao ANTIGA, em cache.

   Medido: depois de publicar uma correcao no ryse-rolagem.js, o navegador
   continuava executando a versao velha, e o arquivo servido na URL sem query
   tinha 1.433 bytes contra os 4.600 recem-enviados. Em producao isso significa
   que cliente NENHUM recebe atualizacao destes dois arquivos.

   Agora a query do proprio ryse-header.js e repassada aos filhos. Ela nao e o
   hash deles - e o dele -, mas resolve o que importa:

     REGRA: ao mexer em ryse-rolagem.js ou ryse-header-core.js, TOQUE TAMBEM
     neste arquivo. Basta subir o numero da revisao no topo. O hash daqui muda,
     a query muda, e os tres sao buscados de novo.

   O certo de verdade seria a secao carregar os tres com {{ ... | asset_url }},
   que fingerprinta cada um. Fica pra quando o ryse-header.liquid for reescrito
   por outro motivo - nao vale reenviar 20 KB de secao por causa disto.
   ========================================================================== */
(function () {
  var src = (document.currentScript && document.currentScript.src) || '';
  var m = src.match(/^(.*\/)ryse-header\.js(\?[^#]*)?/);
  var base = m ? m[1] : '';
  var query = (m && m[2]) || '';

  function carrega(nome) {
    return new Promise(function (ok, falha) {
      var s = document.createElement('script');
      s.src = base + nome + query;
      s.onload = ok;
      s.onerror = falha;
      document.head.appendChild(s);
    });
  }

  carrega('ryse-rolagem.js')
    .then(function () { return carrega('ryse-header-core.js'); })
    .catch(function () {
      /* sem a sentinela o header continua legivel: o CSS cobre o :hover do
         dropdown e a aba fica no estado de topo. Degradar nao pode virar
         quebrar. */
      carrega('ryse-header-core.js').catch(function () {});
    });
})();
